import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    personLogged: boolean = false;
}



// WEBPACK FOOTER //
// C:/DEV/saaristonsiirin/src/app/globals.ts